/**
 * addon-products.js
 * アドオン（追加購入）商品のカート追加処理
 *
 * カートに追加ボタンのクリックを capture phase で横取りし、
 * アドオン商品が選択されている場合はメイン商品と一緒に /cart/add.js へ一括POST。
 * アドオン未選択時は何もせず、既存の CartController に処理を委譲する。
 */
(function () {
  'use strict';

  var addonContainer = document.querySelector('.product-addon-products');
  if (!addonContainer) return;

  var jsonEl = document.querySelector('[data-addon-products-json]');
  if (!jsonEl) return;

  var addonData;
  try {
    addonData = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  /**
   * 選択されたアドオン商品の items 配列を返す
   */
  function getSelectedAddons() {
    var selects = addonContainer.querySelectorAll('.product-addon-products__select');
    var items = [];

    selects.forEach(function (select) {
      if (select.value) {
        items.push({
          id: parseInt(select.value, 10),
          quantity: 1,
          properties: {
            _addon: 'true',
            _bundle_parent: addonData.parentProductTitle
          }
        });
      }
    });

    return items;
  }

  /**
   * フォームからメイン商品の item を構築
   */
  function buildMainItem(form) {
    var formData = new FormData(form);
    var item = {
      id: parseInt(formData.get('id'), 10),
      quantity: parseInt(formData.get('quantity') || '1', 10)
    };

    // properties
    var properties = {};
    formData.forEach(function (value, key) {
      if (key.indexOf('properties[') === 0 && value !== '') {
        var propName = key.replace('properties[', '').replace(']', '');
        properties[propName] = value;
      }
    });
    if (Object.keys(properties).length > 0) {
      item.properties = properties;
    }

    // selling_plan（定期購入）
    var sellingPlan = formData.get('selling_plan');
    if (sellingPlan) {
      item.selling_plan = parseInt(sellingPlan, 10);
    }

    return item;
  }

  /**
   * ボタンの状態を制御
   */
  function setButtonsDisabled(buttons, disabled) {
    buttons.forEach(function (btn) {
      if (disabled) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  /**
   * Capture phase でカート追加ボタンのクリックを監視
   */
  document.addEventListener(
    'click',
    function (e) {
      var button = e.target.closest('[data-js-product-button-add-to-cart]');
      if (!button) return;

      // アドオンが選択されていなければ既存処理に委譲
      var addons = getSelectedAddons();
      if (addons.length === 0) return;

      // フォームを特定（ボタンが form 内にない場合は fallback）
      var form = button.closest('form[action*="/cart/add"]');
      if (!form) {
        form = document.querySelector('.product-page-info form[action*="/cart/add"]')
            || document.querySelector('form[action*="/cart/add"]');
      }
      if (!form) return;

      // イベントを横取り
      e.preventDefault();
      e.stopPropagation();

      // items 配列を構築
      var mainItem = buildMainItem(form);
      var items = [mainItem].concat(addons);

      // ボタンを無効化
      var allButtons = document.querySelectorAll('[data-js-product-button-add-to-cart]');
      setButtonsDisabled(allButtons, true);

      // /cart/add.js に POST
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (response.ok) {
            return response.json().then(function (data) {
              // テーマのカスタムイベントをディスパッチ
              document.dispatchEvent(
                new CustomEvent('theme:cart::added', {
                  detail: { items: data.items || data }
                })
              );

              // テーマのカート UI を更新
              if (typeof theme !== 'undefined' && theme.Cart) {
                return theme.Cart.updateCart().then(function () {
                  theme.Cart.showPopup();
                  setButtonsDisabled(allButtons, false);
                });
              } else {
                window.location.href = '/cart';
              }
            });
          } else {
            return response.json().then(function (err) {
              alert(err.description || 'カートへの追加に失敗しました');
              setButtonsDisabled(allButtons, false);
            });
          }
        })
        .catch(function () {
          alert('カートへの追加に失敗しました');
          setButtonsDisabled(allButtons, false);
        });
    },
    true
  ); // capture phase
})();
